import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import Input from "sushiweb/InputTypes/Input";
import Textarea from "sushiweb/InputTypes/Textarea";
import SpinnerCircular from "sushiweb/Spinner/SpinnerCircular";
import BulkUploadFile from "../../../components/BulkUploadFile";
import DateTimePicker from "../../../components/Common/DateTimePicker";
import NoFooterModal from "../../../components/Common/NoFooterModal";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";
import VideoUploader from "../../../components/Common/VideoUploader";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import * as FleetCoachTaskActions from "../../../store/actions/FleetCoachTask";
import { isValNull } from "../../../utils";
import { InstructionsCSVUpload } from "../../../constants/FleetCoachTask";
import FCAudioUpload from "../FCAudioUpload";

const AUDIO_FILE = "audio_file";
const CSV_FILE = "csv_file";

const TASK_TYPE = [{ key: "AWARENESS_TASK", label: "Awareness Task" }];

function FCTaskCreation(props) {
  const {
    uploadCampaignAudio,
    driverSelectionCSVUpload,
    createFleetCoachTask,
    setInitialState,
    initialState,
    formError,
    setFormError,
    activeFilePath,
    uploadedFileName,
    uploadedVideoName,
    isEditableModal,
  } = props;

  const [modalState, setModalState] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [presign_url, setPresign_url] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");

  const history = useHistory();
  const now = new Date();
  const currentDateTime = now.toISOString().split("T")[0];

  const updateDriverSelectionCSVUpload = (fileData) =>
    driverSelectionCSVUpload().then((data) => {
      return {
        file_path: data?.urls?.[0]?.file_path,
        file_upload_url: data?.urls?.[0]?.upload_url,
        callback_key: true,
      };
    });

  const handleChange = (type, value) => {
    switch (type) {
      //voice note
      case AUDIO_FILE:
      case CSV_FILE:
        setModalState(type);
        break;
      default:
        setInitialState((prevState) => ({ ...prevState, [type]: value }));
    }
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleCloseModal = () => {
    setModalState(false);
  };

  const handleAudioChange = (file) => {
    const payload = {
      filename: file.name,
    };
    uploadCampaignAudio().then((res) => {
      setDownloadUrl(res?.urls?.[0]?.file_path);
      setPresign_url(res?.urls?.[0]?.upload_url);
      setIsUploading(true);
    });
  };

  const handleUrlChange = (mediaType) => {
    setInitialState((prevState) => ({
      ...prevState,
      [mediaType]: downloadUrl,
    }));
    setPresign_url("");
    setDownloadUrl("");
    setIsUploading(false);
    setModalState(false);
  };

  useEffect(() => {
    if (activeFilePath) {
      setInitialState((prevState) => ({
        ...prevState,
        [CSV_FILE]: activeFilePath,
      }));
    } else if (!isEditableModal) {
      setInitialState((prevState) => ({
        ...prevState,
        [CSV_FILE]: null,
      }));
    }
  }, [activeFilePath, isEditableModal]);

  const getModal = (modalState) => {
    switch (modalState) {
      case AUDIO_FILE:
        return (
          <FCAudioUpload
            handleCloseModal={handleCloseModal}
            isUploading={isUploading}
            handleAudioChange={handleAudioChange}
            handleUrlChange={handleUrlChange}
            mediaType={AUDIO_FILE}
            presign_url={presign_url}
          />
        );
        break;

      case CSV_FILE:
        return (
          <section>
            <BulkUploadFile
              instructions={InstructionsCSVUpload}
              btnDataTestID="UpdateDriverSelectionCSVUpload"
              uploadUrl="/fleet_coach/tasks/upload_csv/ack"
              sampleURL="/sample/bulk_upload_fleetcoach_tasks_driver_mapping.csv"
              id="updateDriverSelectionCSVUpload"
              sendExtraAck={true}
              keyName="callback_key"
              heading="Upload CSV file"
              useUserUploadedFilename={true}
              getUploadUrl={updateDriverSelectionCSVUpload}
              customHandleClose={handleCloseModal}
              validationType="FleetCoachTask"
              maxSize={10}
              noAckCall={true}
            />
          </section>
        );
        break;
      default:
        break;
    }
  };

  return (
    <Container>
      <p className="regular mb-30">Task Details</p>
      <FlexContainer className="justify-start">
        <InputElements>
          <PaginatedReactDropdown
            options={TASK_TYPE}
            data-testid="taskType"
            labelKey="label"
            valueKey="key"
            keyToChange="task_type"
            showCross={false}
            id="newTaskTypeDropdown"
            handleChange={handleChange}
            value={getInputLabel(
              initialState?.task_type,
              TASK_TYPE,
              "key",
              "label"
            )}
            placeholder={initialState?.task_type?.split("_").join(" ")}
            disabled
            width="80%"
          />
        </InputElements>
        <InputElements>
          <Input
            value={initialState?.task_heading}
            data-testid="task_heading"
            id="sushi-input"
            onChange={(e) => handleChange("task_heading", e)}
            innerWidth="80%"
            label="Task heading"
            disabled={isEditableModal}
          />
        </InputElements>
      </FlexContainer>
      <FlexContainer className="justify-start">
        <InputElements>
          <Input
            value={initialState.start_date ? initialState.start_date : " "}
            id="sushi-input"
            onChange={(e) => handleChange("start_date", e)}
            min={currentDateTime}
            max={initialState?.end_date}
            label="Select start date"
            type="date"
            disabled={isEditableModal}
          />
        </InputElements>
        <InputElements>
          <Input
            value={initialState.end_date ? initialState.end_date : " "}
            id="sushi-input"
            onChange={(e) => handleChange("end_date", e)}
            min={initialState?.start_date || currentDateTime}
            label="Select end date"
            type="date"
            disabled={isEditableModal}
          />
        </InputElements>
      </FlexContainer>
      <FlexContainer>
        <InputElements className="upload">
          {uploadedVideoName ? (
            <React.Fragment>
              <span>{uploadedVideoName}</span>
            </React.Fragment>
          ) : null}
          {isEditableModal && !uploadedVideoName ? (
            <React.Fragment>
              <span>audio instuctions</span>
            </React.Fragment>
          ) : null}
          <span onClick={(e) => handleChange(AUDIO_FILE)} className="mb-20">
            {uploadedVideoName || isEditableModal
              ? "Edit"
              : "Upload voice note"}
          </span>
        </InputElements>
      </FlexContainer>
      <FlexContainer>
        <Textarea
          id="sushi-textarea"
          data-testid="description"
          borderColor={variables.primaryColor}
          innerWidth="70%"
          className="mb-20"
          resize="none"
          label="Task Description"
          value={initialState?.description}
          fullWidth
          onChange={(e) => handleChange("description", e)}
        />
      </FlexContainer>
      <FlexContainer>
        <InputElements className="upload">
          {uploadedFileName ? (
            <React.Fragment>
              <span>{uploadedFileName}</span>
            </React.Fragment>
          ) : null}
          {isEditableModal && !uploadedFileName ? (
            <React.Fragment>
              <span>dp csv</span>
            </React.Fragment>
          ) : null}
          <span
            onClick={(e) => handleChange(CSV_FILE)}
            className="mb-20 text-blue-800"
          >
            {uploadedFileName || isEditableModal
              ? "Edit"
              : "Upload FC<>DP file for the above task"}
          </span>
        </InputElements>
      </FlexContainer>
      {formError.length > 0 ? (
        <div className={"error-state"}>{"*" + formError}</div>
      ) : null}
      {modalState && getModal(modalState)}
    </Container>
  );
}

const InputElements = styled.div`
  flex: 0 1 50%;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  > span {
    text-decoration: underline;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 50px;
  }
  > span:last-child {
    color: ${variables.blue500};
    display: inline;
  }
  &.upload {
    margin-bottom: 32px;
    span {
      display: flex;
      gap: 6px;
      margin-bottom: 10px;

      p {
        color: ${variables.red500};
      }
    }
  }
`;

const Container = styled.div`
  input[type="date"] {
    width: 80% !important;
  }
  #sushi-textarea {
    textarea {
      min-height: 150px;
    }
  }
`;

function mapStateToProps(state) {
  const { User } = state;
  return {
    activeFilePath: User.activeFilePath,
    uploadedVideoName: User.uploadedVideoName,
    uploadedFileName: User.uploadedFileName,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    uploadCampaignAudio: bindActionCreators(
      FleetCoachTaskActions.uploadCampaignAudio,
      dispatch
    ),
    driverSelectionCSVUpload: bindActionCreators(
      FleetCoachTaskActions.driverSelectionCSVUpload,
      dispatch
    ),
    createFleetCoachTask: bindActionCreators(
      FleetCoachTaskActions.createFleetCoachTask,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FCTaskCreation);
